<template>
  <div class="skeleton progress" :style="skeletonStyle"></div>
</template>

<script>
export default {
  name: 'Skeleton',

  props: {
    width: {
      type: String,
      default: () => ''
    },
    height: {
      type: String,
      default: () => ''
    },
    radius: {
      type: String,
      default: () => ''
    },
  },

  data: () => ({
    skeletonStyle: {}
  }),

  mounted() {
    this.style();
  },

  methods: {
    style() {
      const style = {};

      if (this.width.length) {
        // eslint-disable-next-line dot-notation
        style['width'] = this.width;
      }
      if (this.height.length) {
        // eslint-disable-next-line dot-notation
        style['height'] = this.height;
      }
      if (this.radius.length) {
        style['border-radius'] = this.radius;
      }

      this.skeletonStyle = style;
    }
  }
};
</script>
